import { Input } from "./ui/input";
import { useSession } from "../lib/session";
import { infusionRate, concLabel } from "../lib/infusion";

const InfusionCell = ({ inf, weight, drug }) => {
  const { state, set } = useSession();
  const dose = state.doseEdits?.[drug] ?? inf.dose;
  const setDose = (v) => set("doseEdits", { ...state.doseEdits, [drug]: v });
  const rate = infusionRate(inf, weight, dose);
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        <Input data-testid="infusion-dose-input" type="number" step="any" value={dose} onChange={(e) => setDose(e.target.value)} className="h-7 w-20 text-xs px-2" />
        <span className="text-xs text-muted-foreground">{inf.dose_unit}</span>
      </div>
      <div className="font-mono font-semibold text-[var(--cc-red)]" data-testid="infusion-rate">{rate != null ? `${rate} mL/h` : "—"}</div>
      <div className="text-[11px] text-muted-foreground">{concLabel(inf)}{rate == null && inf.dose_unit?.includes("kg") && !weight ? " · enter weight in Vitals" : ""}</div>
    </div>
  );
};

export const PharmacoTable = ({ meds }) => {
  const { state } = useSession();
  const weight = state.vitals.weight;
  return (
    <div className="overflow-x-auto">
      <div className="text-xs text-muted-foreground mb-2" data-testid="pharmaco-weight">
        {weight ? <>Infusion rates calculated for <b>{weight} kg</b>. Edit a dose to re-titrate.</>
          : <span className="text-[var(--cc-amber)]">No weight entered. Enter weight in Vitals to calculate weight-based infusion rates.</span>}
      </div>
      <table className="w-full text-sm border">
        <thead className="bg-muted"><tr>{["Drug", "Dose", "Route", "Frequency", "Infusion rate", "Notes"].map((h) => <th key={h} className="text-left p-2 border">{h}</th>)}</tr></thead>
        <tbody>{meds.map((m, i) => (
          <tr key={`${m.drug}-${i}`} data-testid={`med-row-${i}`}>
            <td className="p-2 border font-medium">{m.drug}</td><td className="p-2 border">{m.dose}</td><td className="p-2 border">{m.route}</td><td className="p-2 border">{m.frequency}</td>
            <td className="p-2 border min-w-[150px]">{m.infusion ? <InfusionCell inf={m.infusion} weight={weight} drug={m.drug} /> : <span className="text-muted-foreground">—</span>}</td>
            <td className="p-2 border text-muted-foreground">{m.notes}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
};
